<script lang="ts">
  import TopicHubPage from "#lib/components/topics/TopicHubPage.svelte";
  import { PUZZLE_TOPIC_CONFIG } from "#lib/content/topics/puzzles.js";
</script>

<TopicHubPage config={PUZZLE_TOPIC_CONFIG} />
